webpackJsonp([172077923812931],{

/***/ 1323:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Everything a Competent iOS Developer Needs to Know [Graphic]","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/everything-a-competent-ios-developer-needs-to-know","createdAt":"2013-11-08T04:29:07.026Z","blogAuthor":{"fields":{"name":"Brook Riggio and John Bender","slug":"blog/author/brook-riggio-and-john-bender"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/4PJO7DZVhucwq0qC6ii0Ok/83aad379a439ed4e84a9e14c96f42c4d/blog-post-blog-everything-a-competent-ios-developer-needs-to-know.jpg"}}}}}]},"authorJson":{"name":"Brook Riggio and John Bender","slug":"blog/author/brook-riggio-and-john-bender","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/brook-riggio-and-john-bender"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-brook-riggio-and-john-bender-06c58f307ad6aedc9383.js